import React from 'react';
import SectionScroll from './SectionScroll';

export default function Trending() {

  return (
    <SectionScroll
      sectionId="trending"
      title="Trending Posters"
    />
  );
}